import { Select, Tabs } from 'antd';
import { useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import useQuery from '../../util/useQuery';
import ScriptClipboard from './ScriptClipboard';
import ModalPublic from './ModalPublic';
import UserManagementService from '../../services/UserManagement.service';
import UserService from '../../services/UserService';
import DataInventoryService from '../../services/DataInventory.service';
import environment from '../../environments/Environment';
import { useBannerContext } from './context';
import { ROUTER } from '../../constants/router';
import MyCompanyService from '../../services/MyCompany.service';
// import GlobalService from '../../services/Global.service';

import { Button } from 'antd';
import usePermission from '../../hooks/usePermission';
const { TabPane } = Tabs;
const Header = ({
    headerDetail,
    getHeaderDetail,
    domainId,
    setDomainId,
    customize,
    onFinish,
    form,
    setChange,
}) => {
    const UIContext = useBannerContext();
    const UIProps = useMemo(() => {
        return {
            previewLang: UIContext.previewLang,
            setPreviewLang: UIContext.setPreviewLang,
        };
    }, [UIContext]);

    const navigate = useNavigate();
    const params = useQuery();
    const { t } = useTranslation();

    const { Option } = Select;
    const [company, setCompany] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [domainList, setDomainList] = useState([]);
    const [CookieBannerURL, setURL] = useState(
        `<!-- Consent by WhiteFact--> <script type="text/javascript" src="${environment.API_SDK_BANNER}/banner-core.js" cmpUser="Please Select Domain First"></script>`
    );

    const userId = UserService.getUi();

    useEffect(() => {
        setURL(
            `<!-- Consent by WhiteFact-->
            <script type="text/javascript" lang="${UIProps?.previewLang.toUpperCase()}" src="${
                environment.API_SDK_BANNER
            }/banner-core-wf.js" cmpUser="${domainId}"></script>`
        );
    }, [domainId, UIProps?.previewLang]);
    const onChange = async (value) => {
        if (value) {
            setDomainId(value);
        }
    };

    const publishBanner = async (value) => {
        if (
            !value.getFieldsValue()?.useDefaultIcon &&
            !value.getFieldsValue()?.iconCookieId &&
            document.querySelector('.ant-form-item-iconCookieId')
        ) {
            document
                .querySelector('.ant-form-item-iconCookieId')
                .scrollIntoView({ behavior: 'smooth' });
            value.setFields([
                {
                    name: 'iconCookieId',
                    errors: [t('errorText.requiredField')],
                },
            ]);
            return;
        } else {
            setShowModal(true);
        }
    };

    useEffect(() => {
        const getDomainList = async (companyId) => {
            let ObjectSearch = {};
            ObjectSearch = {
                companyId: companyId,
                p: 1,
                ps: 10000,
                s: 'domainName',
                sd: 'ASC',
            };
            try {
                const { data } = await MyCompanyService.getDomainList(
                    ObjectSearch
                );
                const item = data?.resultData;
                setDomainList(item?.result?.filter((e) => e !== null) || []);
            } catch (err) {
                console.log(err);
            }
        };
        const getUserDetail = async () => {
            try {
                const { data } = await UserManagementService.getUserDetail(
                    userId
                );
                const item = data?.resultData;
                if (item?.companyId) {
                    try {
                        const { data } =
                            await DataInventoryService.getCompanyList();
                        const result = data?.resultData?.filter(
                            (i) => i?.id === item?.companyId
                        );
                        setCompany({ name: result[0]?.companyName });
                        getDomainList(item?.companyId);
                    } catch (err) {
                        console.log(err);
                    }
                }
            } catch (error) {
                console.log(error);
            }
        };
        getUserDetail();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const { isAuditor, isUser } = usePermission();

    return (
        <div className="mt-6">
            {/* <StickyContainer>

            </StickyContainer> */}
            <div className="bg-white p-5 rounded-md mb-4">
                <div className="grid grid-cols-3 gap-x-10">
                    <div className="flex flex-col space-y-1">
                        <div className="text-[#65707A] text-xs font-semibold">
                            {t('Domain')}
                        </div>
                        <div>
                            <Select
                                disabled={isAuditor || isUser}
                                className="w-full"
                                size="large"
                                style={{ textAlign: 'left' }}
                                placeholder={t('COOKIE.PleaseSelectDomain')}
                                onChange={onChange}
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    (option?.children ?? '')
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                }
                            >
                                {domainList.map((e) => (
                                    <Option
                                        size="large"
                                        key={e.domainId}
                                        value={e.domainId}
                                    >
                                        {e.domainName}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                    </div>
                    <div className="flex flex-col space-y-1">
                        <div className="text-[#65707A] text-xs font-semibold">
                            {t('COOKIE.Company')}
                        </div>
                        <div className="text-base font-semibold">
                            <div>{company?.name || '-'}</div>
                        </div>
                    </div>
                    <div className="flex flex-col space-y-1">
                        <div className="text-[#65707A] text-xs font-semibold">
                            {t('COOKIE.UpdatedDateAndBy')}
                        </div>
                        <div className="text-base font-semibold">
                            <div>{customize?.updateByFullName || '-'}</div>
                            <div>{customize?.updateDate || '-'}</div>
                        </div>
                    </div>
                    <div />
                </div>
            </div>
            <div className="relative mb-5 tabs bg-white p-5 rounded-md">
                <Tabs
                    // className="tabs bg-white p-5 rounded-md"
                    onChange={(key) => {
                        navigate(
                            `${ROUTER.COOKIE_MANAGEMENT.CUSTOMIZE_BANNER}?tab=${key}`
                        );
                    }}
                    activeKey={params.get('tab') || '1'}
                    // renderTabBar={renderTabBar}
                >
                    <TabPane tab={t('Cookie Banner')} key={1}>
                        <ScriptClipboard
                            code={CookieBannerURL}
                            version={headerDetail?.version}
                            domainId={domainId}
                        />
                        {/* <CookieConsent /> */}
                    </TabPane>
                    <TabPane tab={t('Setting Preference')} key={2}>
                        <ScriptClipboard
                            code={CookieBannerURL}
                            version={headerDetail?.version}
                            domainId={domainId}
                        />
                        {/* <SettingPreference /> */}
                    </TabPane>
                </Tabs>

                {domainId ? (
                    <div className="flex space-x-2 absolute right-6 top-6">
                        <span className="text-[#65707A] text-[12px]">
                            {t('COOKIE.LastPublic')} :{' '}
                            {headerDetail?.publishDate || '-'}
                            {headerDetail?.isFormHaveEdit ? (
                                <>
                                    <div className="text-[#F0536F] text-[12px] text-right">
                                        <span className="text-xl align-middle">
                                            &#8226;
                                        </span>{' '}
                                        {t('common.HaveEditNotPublic')}
                                    </div>
                                </>
                            ) : (
                                <></>
                            )}
                        </span>
                        <div className="flex items-center gap-x-1.5">
                            <Button
                                size="large"
                                type="primary"
                                className="w-[120px]"
                                onClick={() => {
                                    onFinish(form);
                                }}
                            >
                                {t('common.Save')}
                            </Button>
                            <Button
                                size="large"
                                type="primary"
                                onClick={() => {
                                    publishBanner(form);
                                }}
                            >
                                {t('COOKIE.PublicBanner')}
                            </Button>
                        </div>
                    </div>
                ) : (
                    <></>
                )}
            </div>
            <ModalPublic
                open={showModal}
                handelClose={() => setShowModal(false)}
                domainId={domainId}
                nextVersion={headerDetail?.nextVersion}
                getHeaderDetail={getHeaderDetail}
                bannerDetails={form}
                setChange={setChange}
            />
        </div>
    );
};

export default Header;
